var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.event_status)?_c('KpIcon',{attrs:{"tooltip":_vm.$t(_vm.item.event_status),"icon-cls":"bullet","color":`${_vm.item.event_status_icon_color}`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }